module.exports = __webpack_public_path__ + "static/media/08-form.d3ad7308.png";